cv.SetupTeamsRowEmptyView = Marionette.LayoutView.extend({
  className: 'result-empty',
  template: cv.Templates['setup/teams/setup_teams_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('SetupTeamsRowEmptyView initialized');
  },

  onShow: function(){
  }
});
